import React from "react";

interface Briefing {
  id: string;
  title?: string;
  createdAt?: { _seconds: number };
}

interface BriefingsModalProps {
  allBriefings: Briefing[];
  selectedBriefing: number | null;
  setSelectedBriefing: (index: number) => void;
  closeModal: () => void;
  handleBriefingSelect: (id: string) => void;
  epochToDateStringWithYear: (epochSeconds: number) => string;
}

const BriefingsModal: React.FC<BriefingsModalProps> = ({
  allBriefings,
  selectedBriefing,
  setSelectedBriefing,
  closeModal,
  handleBriefingSelect,
  epochToDateStringWithYear,
}) => {
  return (
    <div className="custom-modal-overlay" onClick={closeModal}>
      <div
        className="custom-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="custom-close-button" onClick={closeModal}>
          ×
        </button>
        <div className="briefings-modal">
          <h2 style={{ marginBottom: "20px", color: "#333" }}>All Briefings</h2>
          <div className="briefings-list">
            {allBriefings && allBriefings.length > 0 ? (
              allBriefings.map((briefing, index) => (
                <div
                  key={index}
                  className={`briefing-item ${
                    selectedBriefing === index ? "selected" : ""
                  }`}
                  onClick={() => setSelectedBriefing(index)}
                >
                  <div className="briefing-radio">
                    <input
                      type="radio"
                      name="briefingSelection"
                      id={`briefing-${index}`}
                      checked={selectedBriefing === index}
                      onChange={() => setSelectedBriefing(index)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <label htmlFor={`briefing-${index}`}></label>
                  </div>
                  <div className="briefing-content">
                    <h4 style={{ margin: "0 0 8px 0", color: "#555" }}>
                      {briefing.title || `Briefing ${index + 1}`}
                    </h4>
                    {briefing.createdAt && (
                      <small style={{ color: "#999", fontSize: "12px" }}>
                        Created:{" "}
                        {epochToDateStringWithYear(
                          briefing.createdAt?._seconds
                        )}
                      </small>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: "#666", textAlign: "center" }}>
                No briefings available
              </p>
            )}
          </div>
          <div
            className="modal-actions"
            style={{ marginTop: "20px", textAlign: "right" }}
          >
            <button
              className="send-to-all-button"
              disabled={selectedBriefing === null}
              onClick={() => {
                if (selectedBriefing !== null) {
                  handleBriefingSelect(allBriefings[selectedBriefing].id);
                  setTimeout(() => {
                    closeModal();
                  }, 1000);
                }
              }}
              style={{
                marginRight: "10px",
                opacity: selectedBriefing === null ? 0.6 : 1,
                cursor: selectedBriefing === null ? "not-allowed" : "pointer",
              }}
            >
              Confirm Send
            </button>
            <button
              className="cancel-button"
              onClick={closeModal}
              style={{
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BriefingsModal;
